import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.9639 5.75466C11.6359 5.43066 11.1019 5.43066 10.7739 5.75466L7.99924 8.48399L5.22591 5.75466C4.89657 5.43066 4.36391 5.43066 4.03457 5.75466C3.87057 5.91666 3.78857 6.12866 3.78857 6.34066C3.78857 6.55266 3.87057 6.76532 4.03457 6.92666L7.40457 10.2427C7.73391 10.5667 8.26657 10.5667 8.59591 10.2427L11.9646 6.92666C12.2932 6.60332 12.2932 6.07866 11.9639 5.75466Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}